import { useMemo } from "react";
import { useSelector } from "react-redux";
import { dataPaginationSelector } from "Bands/state";

export const usePagination = (paginationKey: string) => {
  const paginationSelector = useMemo(() => dataPaginationSelector(paginationKey), [paginationKey]);
  const pagination = useSelector(paginationSelector);

  return pagination;
};
